import { Statement, StatementStatus } from 'app/dataTypes/cafeteria/compensation/statements'

import { Column } from '../columns'
import { Status } from './Status'
import { Actions } from './Actions'


type Props = {
  statement: Statement
  columnKey: Column
  onRemove: (ID: string) => void
  onEdit: (ID: string) => void
  disabled?: boolean
}

export const Cell = ({ statement, columnKey, onRemove, onEdit, disabled }: Props) => {
  const { ID, status, date, value } = statement

  if (columnKey === Column.Status) {
    return <Status ID={ID} status={status} />
  }

  if (columnKey === Column.Date) {
    return <div>{date.getString('DD.MM.YYYY hh:mm')}</div>
  }

  if (columnKey === Column.Value) {
    return <div>{value}</div>
  }

  if (columnKey === Column.Action) {
    return (
      <Actions
        ID={ID}
        onRemove={
          status === StatementStatus.Consideration
          || status === StatementStatus.Draft
            ? onRemove
            : undefined
        }
        onEdit={status === StatementStatus.Draft ? onEdit : undefined}
        disabled={disabled}
      />
    )
  }

  return <div>{'—'}</div>
}
